export default "__VITE_ASSET__CYVhVBc5__"